import React from 'react';
import styled from 'styled-components';
import { Navigation } from '../Navigation/Navigation';
import { HERO_CONFIG } from '../../../utils/constants';

const HeaderContainer = styled.header<{ $backgroundImage?: string }>`
  background-image: url(${props => props.$backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: ${HERO_CONFIG.HEIGHT}px;
  display: flex;
  flex-direction: column;
  transition: background-image 0.5s ease-in-out;
`;

const SiteTextContainer = styled.div`
  height: ${HERO_CONFIG.HEIGHT}px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
`;

const SiteText = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  text-shadow: ${({ theme }) => theme.shadows.text};
`;

const SiteLogo = styled.img`
  width: auto;
  height: auto;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  margin-left: ${({ theme }) => theme.spacing.sm};
`;

const SiteTitle = styled.h1`
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
  text-shadow: ${({ theme }) => theme.shadows.text};
`;

const SiteDescription = styled.p`
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
  font-size: 1.1rem;
  text-shadow: ${({ theme }) => theme.shadows.text};
`;

interface HeaderProps {
  backgroundImage?: string;
  logo?: string;
  title?: string;
  description?: string;
}

export const Header: React.FC<HeaderProps> = ({
  backgroundImage,
  logo,
  title,
  description,
}) => {
  return (
    <HeaderContainer $backgroundImage={backgroundImage}>
      <SiteTextContainer>
        <SiteText>
          {logo && (
            <SiteLogo 
              src={logo} 
              alt="Diabetes Live NZ Logo" 
              loading="eager"
            />
          )}
          {title && <SiteTitle>{title}</SiteTitle>}
        </SiteText>
      </SiteTextContainer>
      <Navigation />
    </HeaderContainer>
    // <HeaderContainer $backgroundImage={backgroundImage}>
    //   <SiteTextContainer>
    //     <SiteText>
    //       {logo && (
    //         <SiteLogo 
    //           src={logo} 
    //           alt="Diabetes Live NZ Logo" 
    //           loading="eager"
    //         />
    //       )}
    //       {title && <SiteTitle>{title}</SiteTitle>}
    //       {description && <SiteDescription>{description}</SiteDescription>}
    //     </SiteText>
    //   </SiteTextContainer>
    //   <Navigation />
    // </HeaderContainer>
  );
};

export default Header;
